import React, {useEffect, useMemo, useState} from "react";
import GridBlock from "components/GridBlock";
import Button from "components/Button";
import PropTypes from 'prop-types';
import Tr from 'translations/Translations'
import ResultNoticeService from "services/ResultNoticeService";
import isResponseValid from "libs/isResponseValid";
import TypographyWithIcon from "components/TypographyWithIcon";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import Typography from "components/Typography";
import {makeStyles} from "@material-ui/core";
import validateSection from "../../../../../../../../services/helpers/validateSection";
import {DemandValidation} from "../../../../../../../../constants/DemandValidation";
import {connect} from "react-redux";
import {PublishConst} from 'constants/PublicationConst';
import ResultNoticeType from "../constants/ResultNoticeType";
import clsx from "clsx";

const useStyle = makeStyles(theme => ({
    text: {
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(4)
    },
    text1: {
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1)
    },
    error: {
        color: theme.palette.common.error
    }
}))

function OjsResultNotice(
    {
        demandId,
        editable,
        ojsAdmin,
        resultNotice,
        ojsResultNoticeSend,
        canPublishOjsResultNotice,
        resultOjsPublicationStatus
    }) {
    const classes = useStyle();

    const [working, setWorking] = useState(false);
    const [error, setError] = useState(null);
    const hasOjsNotice = useMemo(() => resultNotice ? resultNotice.type === ResultNoticeType.OJS && resultNotice.identity > 0 && resultNotice.complete : false, [resultNotice]);
    const [resultNoticeStatusInterval, setResultNoticeStatusInterval] = useState();

    useEffect(() => {
        if (hasOjsNotice) {
            ResultNoticeService.checkOjsResultNotice(demandId).then(resp => {
                setWorking(false);
                if (resp && resp.status === PublishConst.SENT) {
                    startResultNoticeStatusInterval();
                }
            })
        } else {
            setWorking(false);
        }

        return () => {
            if (resultNoticeStatusInterval) clearInterval(resultNoticeStatusInterval);
        }
        //eslint-disable-next-line
    }, []);

    const startResultNoticeStatusInterval = () => {
        const interval = setInterval(async () => {
            const resp = await ResultNoticeService.checkOjsResultNotice(demandId);
            if (resp.status !== PublishConst.SENT) {
                clearInterval(interval);
                //clearPublishResources();
            }
        }, 10000);
        setResultNoticeStatusInterval(interval);
    };

    const goToNotice = () => {
        window.location.href = resultNotice.url;
    };

    const publishOjsResultNotice = () => {
        setWorking(true)
        ResultNoticeService.publishOjsResultNotice(demandId).then(resp => {
            if (isResponseValid(resp, setError)) {
                startResultNoticeStatusInterval();
                validateSection(DemandValidation.RESULT_NOTICE, demandId, false).finally(() => setWorking(false));
            }
        })
    };

    const rollbackOjsResultNotice = () => {
        setWorking(true)
        ResultNoticeService.rollbackOjsResultNotice(demandId).then(resp => {
            ResultNoticeService.checkOjsResultNotice(demandId).then(resp => {
                setWorking(false);
                startResultNoticeStatusInterval();
            });
            //clearPublishResources();
            if (isResponseValid(resp, setError)) {
                validateSection(DemandValidation.RESULT_NOTICE, demandId, false).finally(() => setWorking(false));
            }
        });
    };

    const unpublishResultNotice = () => {
        setWorking(true);
        ResultNoticeService.unpublishResultNotice(demandId, resultNotice.identity).then(resp => {
            if (isResponseValid(resp, setError)) {
                validateSection(DemandValidation.RESULT_NOTICE, demandId, false).finally(() => setWorking(false));
            }
        });
    };

    const publishResultNotice = () => {
        setWorking(true);
        ResultNoticeService.publishResultNotice(demandId, resultNotice.identity).then(resp => {
            if (isResponseValid(resp, setError)) {
                validateSection(DemandValidation.RESULT_NOTICE, demandId, false).finally(() => setWorking(false));
            }
        });
    }


    return (<GridBlock
        direction='column'
        alignItems='center'
    >
        {!!error && <TypographyWithIcon Icon={ErrorOutlineIcon} color='error'>{error}</TypographyWithIcon>}

        {!canPublishOjsResultNotice && !ojsResultNoticeSend && <Typography className={classes.text1}>{Tr('result_notice_ojs_prepare')}</Typography>}
        <Button disabled={working}
                onClick={goToNotice}>{Tr(ojsResultNoticeSend ? 'preview_union_result_annoucement' : 'create_union_result_annoucement')}</Button>

        {hasOjsNotice && (resultOjsPublicationStatus && resultOjsPublicationStatus.message && resultOjsPublicationStatus.status !== PublishConst.UNAVAILABLE) &&
        <Typography className={clsx(classes.text, {
            [classes.error]: resultOjsPublicationStatus.status === PublishConst.ERROR
            || resultOjsPublicationStatus.status === PublishConst.UE_VALIDATION_ERROR || resultOjsPublicationStatus.status === PublishConst.NOT_PUBLISHED
        })}>
            {resultOjsPublicationStatus.message}
        </Typography>
        }
        {hasOjsNotice && !resultOjsPublicationStatus &&
        <Typography className={clsx(classes.text)}>
        </Typography>
        }
        {hasOjsNotice && (!resultOjsPublicationStatus || (resultOjsPublicationStatus.status !== PublishConst.NOT_PUBLISHED && resultOjsPublicationStatus.status !== PublishConst.UE_VALIDATION_ERROR)) &&
        <Button disabled={working || !editable || !canPublishOjsResultNotice} onClick={publishOjsResultNotice}>{Tr('send_eu_publish')}</Button>
        }

        {hasOjsNotice && resultOjsPublicationStatus && resultOjsPublicationStatus.status === PublishConst.NOT_PUBLISHED &&
        <Button disabled={working || !editable} onClick={rollbackOjsResultNotice}>{Tr('send_eu_publish_rollback')}</Button>
        }

        {hasOjsNotice && resultOjsPublicationStatus && resultOjsPublicationStatus.status === PublishConst.UE_VALIDATION_ERROR &&
        <Button disabled={working || !editable || !ojsAdmin} onClick={rollbackOjsResultNotice}>{Tr('send_eu_publish_rollback')}</Button>
        }

        {hasOjsNotice && <Typography className={classes.text}>{Tr(resultNotice.published ? 'result_notice_published' : 'result_notice_not_published')}</Typography>}

        {hasOjsNotice && resultNotice.published &&
        <Button disabled={working || !editable} onClick={unpublishResultNotice}>{Tr('result_notice_unpublish')}</Button>
        }

        {hasOjsNotice && !resultNotice.published &&
        <Button disabled={working || !editable} onClick={publishResultNotice}>{Tr('result_notice_publish')}</Button>
        }
    </GridBlock>)
}

OjsResultNotice.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    editable: PropTypes.bool.isRequired,
    resultNotice: PropTypes.shape({
        url: PropTypes.string.isRequired
    }).isRequired,
    canPublishOjsResultNotice: PropTypes.bool.isRequired,
    ojsResultNoticeSend: PropTypes.bool.isRequired,

}

export default connect((state) => ({
    resultOjsPublicationStatus: state.resources.resultOjsPublicationStatus
}), {})(OjsResultNotice);